module.exports = __WEBPACK_EXTERNAL_MODULE_286__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/ui/Multitouch","root":["openfl","ui","Multitouch"],"commonjs":"openfl/ui/Multitouch","commonjs2":"openfl/ui/Multitouch"}
// module id = 286
// module chunks = 0